<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderSSPSlim />
      </slot>
    </template>

    <div class="content-box">
      <div class="two-column-grid">
        <div>{{ $t('railsEarthed') }}</div>
        <div>{{ $t(project.serviceReport.railsEarthed) }}</div>
      </div>
    </div>
    <AttachmentsPrintGrid
      :attachments="project.serviceRailOverlappingTerminationFittingAttachments"
      fieldName="serviceRailOverlappingTerminationFittingAttachments"
      :maxImages="4"
    />
    <AttachmentsPrintGrid
      :attachments="project.serviceCorrectCableInputAttachments"
      fieldName="correctCableInputAttachments"
      fieldDescription="correctCableInputAttachments"
      :maxImages="4"
    />

    <AttachmentsPrintGrid
      :attachments="project.serviceProtectedUnderBrickCableRoutingAttachments"
      fieldName="protectedUnderBrickCableRoutingAttachments"
      fieldDescription="protectedUnderBrickCableRoutingAttachments"
      :maxImages="4"
    />
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'BrickAndSubstructurePrintPage2',
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
